import React from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function WEditor(props) {
    const onEditorStateChange = (editorState) => {
        props.handleChange(editorState);
    };
    // useEffect(() => {
    //     if (editor) {
    //         console.log('destroying editor');
    //         return () => editor.destroy().catch(error => console.log(error))
    //     }
    // }, [])
    // const [editor, setEditor] = useState(null);
    const content = props.existing || '';
    return (
        <>
            <CKEditor
                config={{
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                    placeholder: "Express your views...",
                }}
                editor={ClassicEditor}
                data={content}
                onInit={editor => {
                    // setEditor(editor);
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    editor.UploadFile = (...e) => props.handleUploadFile(...e);
                    if (content) { editor.setData(content) }
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    onEditorStateChange(data);
                }}
                onError={(e) => {
                    console.log(e);
                }}
            />
        </>
    )
}

class MyUploadAdapter {
    constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._initListeners(resolve, reject, file);
            }));
    }

    // Aborts the upload process.
    abort() {
        console.log('aborted');
    }

    // Initializes XMLHttpRequest listeners.
    _initListeners(resolve, reject, file) {
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${file.name}.`;
        loader.UploadFile(file, (evnt, response) => {
            if (!evnt || evnt === 'fail') {
                return reject(response && response.error ? response.error.message : genericErrorText);
            }
            if (!evnt || evnt === 'success') {
                resolve({
                    default: response.url
                });
            }
        });

    }

}

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        console.log(editor);
        loader.UploadFile = editor.UploadFile;
        // Configure the URL to the upload script in your back-end here!
        return new MyUploadAdapter(loader);
    };
}

export { WEditor as Editor }

